import quickFetch from 'quick-fetch';
import { getApiClient } from './apiClient';
let apiBase = 'ecosystem/v1';
export const setEcosystemApiBase = _apiBase => {
  apiBase = _apiBase;
};
export function getQuickFetch(requestName, newRelicAttribute) {
  const earlyRequest = quickFetch.getRequestStateByName(requestName);
  if (!earlyRequest) return Promise.reject(new Error(`No early request found: ${requestName}`));

  if (newRelicAttribute && window.newrelic) {
    window.newrelic.setCustomAttribute(newRelicAttribute, Boolean(earlyRequest.finished));
  }

  return new Promise((resolve, reject) => {
    earlyRequest.whenFinished(result => {
      quickFetch.removeEarlyRequest(requestName);
      resolve(result);
    });
    earlyRequest.onError(() => {
      quickFetch.removeEarlyRequest(requestName);
      reject(new Error(`Early request failed: ${requestName}`));
    });
  });
}
export function getCollections(appContext) {
  return getQuickFetch('collections').catch(() => {
    const path = appContext === 'ADMIN_PREVIEW' ? 'ecosystem/admin/v1/self-serve/themes/collections' : `${apiBase}/self-serve/themes/collections/published`;
    return getApiClient().get(path);
  });
}
export function getCallouts() {
  return getQuickFetch('callouts').catch(() => {
    return getApiClient().get(`${apiBase}/self-serve/callouts/published?offeringType=THEME`);
  });
}
export function getThemeCollectionItems(collectionId) {
  return getApiClient().get(`${apiBase}/self-serve/themes/collections/${collectionId}/items`);
}
export function getThemeCollectionPreviewItems(collectionId) {
  return getApiClient().get(`ecosystem/admin/v1/self-serve/themes/collections/${collectionId}/items`);
}
export const getSearchTags = offeringType => {
  return getApiClient().get(`${apiBase}/${offeringType === 'MODULE' ? 'modules' : 'themes'}/search-tags`);
};
export function getThemeProviders() {
  return getQuickFetch('theme-providers').catch(() => {
    return getApiClient().get(`${apiBase}/providers/names`, {
      query: {
        'offering-type': 'THEME'
      }
    });
  });
}
export function getModuleProviders() {
  return getQuickFetch('module-providers').catch(() => {
    return getApiClient().get(`${apiBase}/providers/names`, {
      query: {
        'offering-type': 'MODULE'
      }
    });
  });
}
export function getProviders(offeringType) {
  return offeringType === 'THEME' ? getThemeProviders() : getModuleProviders();
}
export function getUnusedFilters() {
  return getQuickFetch('unused-filters', 'unused-filters-early-request-used').catch(() => {
    const path = `${apiBase}/themes/unused-filters`;
    return getApiClient().get(path);
  });
}
export const fetchReviewability = offeringId => {
  return getApiClient().get(`${apiBase}/reviews/reviewability/offerings/${offeringId}`);
};
export const writeReview = review => {
  return getApiClient().post(`${apiBase}/reviews`, {
    data: review
  });
};
export const fetchReviews = (queries, reviewType) => {
  return getApiClient().post(`${apiBase}/reviews/search`, {
    data: Object.assign({}, queries, {
      reviewType
    })
  });
};
export const fetchReviewStats = (offeringId, reviewType) => getApiClient().post(`${apiBase}/reviews/stats`, {
  data: {
    offeringId,
    reviewType
  }
});
export const toggleHelpful = (reviewId, isHelpful) => {
  return getApiClient().put(`${apiBase}/reviews/${reviewId}/helpful`, {
    data: isHelpful
  });
};
export const reportReview = (reviewId, reason, comment) => getApiClient().post(`${apiBase}/reviews/${reviewId}/report`, {
  data: {
    reason,
    comment
  }
});
export const reportReply = (reviewId, replyId, reason, comment) => getApiClient().post(`${apiBase}/reviews/${reviewId}/replies/${replyId}/report`, {
  data: {
    reason,
    comment
  }
});
export const purchase = purchaseInfo => getApiClient().post(`${apiBase}/transactions/sales`, {
  data: purchaseInfo
});
export const getModuleDetails = slug => getApiClient().get(`${apiBase}/modules/details`, {
  query: {
    slug
  }
});
export const getModuleDetailsPreview = slug => getApiClient().get(`${apiBase}/modules/details/preview`, {
  query: {
    slug
  }
});
export function searchAssets(offeringType, queries) {
  const url = offeringType === 'THEME' ? `${apiBase}/themes/search` : `${apiBase}/modules/search`;
  return getApiClient().post(url, {
    data: queries
  });
}
export const getThemeDetails = slug => getApiClient().get(`${apiBase}/themes/details`, {
  query: {
    slug
  }
});
export const getThemeDetailsPreview = slug => getApiClient().get(`${apiBase}/themes/details/preview`, {
  query: {
    slug
  }
});
export const getAcademyCertifications = () => getApiClient().get(`${apiBase}/academy/certifications`);
export const getVersionHistory = ({
  offeringId,
  offset,
  limit
}) => getApiClient().get(`${apiBase}/offerings/versions/history`, {
  query: {
    offeringId,
    offset,
    limit
  }
});
export function getAssetInstallability(offeringId) {
  return getApiClient().get(`${apiBase}/assets/${offeringId}/installability`);
}
export function getCompatibility(offeringType) {
  return getApiClient().get(`${apiBase}/compatibility/${offeringType === 'THEME' ? 'themes' : 'modules'}`);
}